import { useState, useCallback, useEffect } from "react"
import _uniqueId from "lodash/uniqueId"

const useToast = () => {
  const [openedToasts, setOpenedToasts] = useState([])
  const [delay, setDelay] = useState(2000)

  const openToast = useCallback(({ iconName, desc, top, bottom, delay }) => {
    if (delay) setDelay(delay)

    setOpenedToasts((toasts) => [
      ...toasts,
      { id: _uniqueId("toast_"), iconName, desc, top, bottom },
    ])
  }, [])

  const closeToast = useCallback(() => {
    setOpenedToasts((toasts) => {
      toasts.shift()
      return [...toasts]
    })
  }, [])

  useEffect(() => {
    if (openedToasts.length > 0) {
      setTimeout(() => closeToast(), delay)
    }
  }, [closeToast, delay, openedToasts.length])

  return { openedToasts, openToast, closeToast }
}

export default useToast
